import ModalNewSimulationComponent from './ModalNewSimulation/ModalNewSimulation'

export const ModalNewSimulation = ModalNewSimulationComponent
